import { inferRouteObject } from 'react-router-typed-object';

import { PrivateRoute, Roles, or } from '@/js/libs/use-auth';

import RoleBasedRedirector, { type Condition } from 'src/components/RoleBasedRedirector.tsx';
import { AnalyticsTool } from 'src/scenes/AnalyticsTool/index.ts';
import Status from 'src/scenes/Status/index.ts';

const homeConditions: Condition[] = [
  { roles: Roles.ANALYTICS_TOOL, to: '/analytics-tool/page-impressions' },
  { roles: Roles.ADMIN, to: '/analytics-tool/fill-rate-attribution' },
];

const index = true;

export const analyticsToolObject = inferRouteObject({
  path: 'analytics-tool',
  element: <PrivateRoute roles={or(Roles.ANALYTICS_TOOL, Roles.ADMIN)} noAccessComponent={Status.NotFound} />,
  children: [
    {
      Component: AnalyticsTool.Helmet,
      children: [
        { index, element: <RoleBasedRedirector conditions={homeConditions} noAccessElement={<Status.NotFound />} /> },
        {
          element: <PrivateRoute roles={Roles.ANALYTICS_TOOL} noAccessComponent={Status.NotFound} />,
          children: [
            { path: 'page-impressions', Component: AnalyticsTool.PageImpressions },
            { path: 'ad-impressions', Component: AnalyticsTool.AdImpressions },
          ],
        },
        {
          path: 'fill-rate-attribution',
          element: <PrivateRoute roles={Roles.ADMIN} noAccessComponent={Status.NotFound} />,
          children: [{ index, Component: AnalyticsTool.FillRateAttribution }],
        },
      ],
    },
  ],
});
